<template>	
	<a-row type="flex">
		<a-col span="4" :md="2" :sm="3" v-if="mylogo">
			<img id="logo_header" src="images/logos/netplus.svg" alt="Netplus SVG" >
		</a-col>
		<a-col span="12" :xl="12" :lg="12" :md="11" :sm="20" :xs="20">
			<RouteComponent 
			:clienteName="userInfo" 
			:sidebarCollapsed="sidebarCollapsed"
			@updateCollapse="updateCollapse"
		/>
		</a-col>
		<a-col span="12" :xl="12" :lg="12" :md="11" :sm="24" :xs="24">
			<ProfileComponent
				v-if="typeMenu == 'client'" 
				class="header-control" 
				:myscreen="myscreen"
				@toggleProfileDrawer="$emit('toggleProfileDrawer', true)" 
				@redirect_logout="$emit('redirect_logout')"
			/>
			<ProfileSystem v-else 
				class="header-control" 
				:myscreen="myscreen"
				@toggleProfileDrawer="$emit('toggleProfileDrawer', true)" 
				@redirect_logout="$emit('redirect_logout')"
			/>
		</a-col>
	</a-row>
</template>
<script>
	import RouteComponent from './Route.vue';
	import ProfileComponent from './Profile.vue';
	import ProfileSystem from './ProfileSystem.vue';
	import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons-vue';
	export default ({
		emits: ['toggleProfileDrawer', 'redirect_logout', 'toggleSidebar' ],
		components: {
			RouteComponent,
			ProfileComponent,
			ProfileSystem,
			MenuFoldOutlined, 
			MenuUnfoldOutlined
		},
		props: {
			// Header fixed status.
			navbarFixed: {
				type: Boolean,
				default: false,
			},
			// Sidebar collapsed status.
			sidebarCollapsed: {
				type: Boolean,
				default: false,
			},
			typeMenu: {
				type: String,
				default: 'client'
			}
		},
		data() {
			return {
				userInfo: null,
				top: 0,
				searchLoading: false,
				wrapper: document.body,
				visible: false,
				// cliente: this.$route.meta.myCliente,
				messageCount: 0,
				showProfileDrawer: false,
				myscreen: false,
				mylogo: false,
            	breakpoints: {
                	xs: 480,
                	sm: 576,
                	md: 768,
                	lg: 992,
                	xl: 1200,
            	},
			}
		},
		methods: {
			resizeEventHandler(){
				this.top = this.top ? 0 : -0.01 ;
				// To refresh the header if the window size changes.
				// Reason for the negative value is that it doesn't activate the affix unless
				// scroller is anywhere but the top of the page.
			},
			onSearch(value){
			},
			handleClose() {
     			this.visible = false;
    		},
			emitToggleProfileDrawer() {
      			this.$emit('toggleProfileDrawer', true);
    		},
			updateCollapse(show) {
    			this.$emit('toggleSidebar', show)
			},
			getColSpan() {
				if (window.innerWidth <= this.breakpoints.md) {
					this.mylogo = true;
					return true; 
				} else if (window.innerWidth <= this.breakpoints.lg) {
					this.mylogo = true;
					return false; 
				} else {
					this.mylogo = false;
					return false; 
				}
			},
		},
		mounted: function() {
			// console.log(this.$route)
			setInterval( () => {
				switch(this.$route.meta.layout) {
					case "system":
						this.userInfo = this.$route.meta.mySystem?.[0]?.name
						break;
					default:
						this.userInfo = this.$route.meta.myCliente?.[0]?.name;
						break;
				}
            	this.myscreen = this.getColSpan();
        	}, 1000)			
		},
		computed: {
			screenWidth() {
         	   return window.innerWidth;
        	}
		},
		created: function() {
			window.addEventListener('resize', () => {
				this.myscreen = this.getColSpan();
			});
		},
		beforeDestroy() {
			window.removeEventListener('resize', () => {
				this.myscreen = this.getColSpan();
			});
		},
	})

</script>
<style lang="scss">
#logo_header {
  @media (max-width: 768px) { // Equivalente a tamaño de pantalla menor o igual a md en Bootstrap
    margin-bottom: 1em;
    padding-right: 10px;
  }

  @media (max-width: 1200px) { // Equivalente a tamaño de pantalla menor o igual a lg en Bootstrap
    padding-right: 5px;
  }
}
</style>